import React from "react";
import { SelectableChatBoxListDispatchContext } from "../SelectableChatBoxListContext";

export const useSelectableChatBoxListDispatch = () => {
	return React.useContext(SelectableChatBoxListDispatchContext);
};
